import styled from "styled-components";

import { DashboardMain } from "../../styles/adminPage";
import { md3CardRadius } from "../../shared/styles/md3Components";
import {
  actionListSubtitle,
  fontSizes,
  lineHeights,
  md3LabelLarge,
  sectionTitle,
} from "../../shared/styles/typography";

export { Container, AddButton, PageWrapper } from "../../styles/adminPage";

export const Main = styled(DashboardMain)`
  margin-top: 0;

  section {
    background: ${({ theme }) => theme.colors.card};
    border-radius: ${({ theme }) => md3CardRadius(theme)}px;
    box-shadow: ${({ theme }) => theme.shadows.md3Level1};
    border: 1px solid ${({ theme }) => theme.colors.border};
    padding: 2.4rem;

    h1 {
      ${sectionTitle}
      margin-bottom: 1.6rem;
    }
  }
`;

export const DetailCard = styled.section`
  background: ${({ theme }) => theme.colors.card};
  border-radius: ${({ theme }) => md3CardRadius(theme)}px;
  box-shadow: ${({ theme }) => theme.shadows.md3Level1};
  border: 1px solid ${({ theme }) => theme.colors.border};
  padding: 2.4rem;
  max-width: 720px;
`;

export const MetaRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-bottom: 1.6rem;

  &:last-child {
    margin-bottom: 0;
  }

  code {
    font-size: ${fontSizes.base}px;
    line-height: ${lineHeights.base}px;
    word-break: break-all;
    color: ${({ theme }) => theme.colors.text};
  }
`;

export const Label = styled.span`
  ${md3LabelLarge}
  color: ${({ theme }) => theme.colors.textSecondary};
`;

export const ListIntro = styled.p`
  ${actionListSubtitle}
  margin-bottom: 1.2rem;
`;
